import { http } from '@/helpers/easyindustriaapi/config';

/**
 * Service para API de senhas/tickets (triagem/recepção).
 * Endpoints: POST /senhas/gerar, POST /senhas/chamar, GET /senhas/painel, PUT /senhas/:id/atendido
 */
export default class TicketsController {
    constructor(user, empresa) {
        this.currentUser = user;
        this.currentEmpresa = empresa;
    }

    /**
     * Gera nova senha. Tipo: 'normal' | 'preferencial'
     */
    async generate(tipo = 'normal') {
        const payload = { tipo, empresa_id: this.currentEmpresa?.id };
        const { data } = await http.post('/senhas/gerar', payload);
        return data;
    }

    /**
     * Chama a próxima senha para o guichê.
     */
    async callNext(guiche) {
        const { data } = await http.post('/senhas/chamar', { guiche, empresa_id: this.currentEmpresa?.id });
        return data;
    }

    /**
     * Polling para a TV: último registro com status chamando do dia.
     */
    async pollTv() {
        const { data } = await http.get(`/senhas/painel?empresa_id=${this.currentEmpresa?.id}`);
        return data;
    }

    /**
     * Marca a senha como atendida.
     */
    async markAsAtendido(id) {
        const { data } = await http.put(`/senhas/${id}/atendido`);
        return data;
    }
}
